module.exports = __webpack_public_path__ + "img/upload_idea.8c972849.png";